import { Component, ViewChild } from '@angular/core';
import { IonNav, Platform } from '@ionic/angular';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  @ViewChild(IonNav) nav: IonNav;

  public appPages = [
    { title: 'Home', url: '/home', icon: 'home', color: 'secondary' },
    { title: 'Student Evaluations', url: '/studentevaluations', icon: 'create', color: 'danger' },
    { title: 'Clerkship Goals and Objectives', url: '/clerkshipgoals', icon: 'information-circle', color: 'primary'},
    { title: 'Teachers Resources', url: '/teachersresources', icon: 'document', color: 'primary'},
    { title: 'Graduation Competencies', url: '/gradcompetencies', icon: 'school', color: 'primary' },
    { title: 'Professionalism Reporting/Mistreatment Policies', url: '/mistreatment', icon: 'sad', color: 'secondary' },
    { title: 'Blood and Bodily Fluid Exposure', url: '/exposure', icon: 'water', color: 'danger' },
    { title: 'Report of Exemplary Professionalism', url: '/reportexemplprof', icon: 'create', color: 'primary' },
    { title: 'Report of Concern for Unprofessional Behavior', url: '/reportunprofbehavior', icon: 'create', color: 'primary' },
    { title: 'Contact Us', url: '/contactus', icon: 'call', color: 'primary' }
  ];

  //public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  constructor(public platform: Platform, private statusBar: StatusBar, private splashScreen: SplashScreen) 
  { 
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(true);
      this.splashScreen.hide();
    });
  } 

}
